import React from "react";
import { Theme } from "@pga/pga-component-library";
import Paragraph, { ParagraphContainer } from "./common/Paragraph";
import styled from "styled-components";

const JobInfoItemContainer = styled.div`
  display: block;
  margin: 10px 0px;

  h3 {
    margin: 0px;
    color: ${Theme.colors.blueGrey};
    font-family: ${Theme.fonts.Montserrat};
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: left;
  }

  ${ParagraphContainer} {
    color: ${Theme.colors.primary};
    font-size: 14px;
    font-weight: 300;
    @media (min-width: 768px) {
    }
  }
`;

export default ({ title, children, isLast }) => (
  <JobInfoItemContainer>
    <h3>{title}</h3>
    <Paragraph>{children}</Paragraph>
    {!isLast && <hr />}
  </JobInfoItemContainer>
);
